/* eslint-disable @nx/enforce-module-boundaries */
import {
  Box,
  Button,
  HStack,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Select,
  Stack,
  Text,
} from '@mybridge/ui';
import { useContext, useEffect, useState } from 'react';
import { TeamsContext } from '../../context';
import { getUserFullName } from 'v4/lib/commons';
import { useTranslator } from '@mybridge/ui/custom-hooks/useTranslation';
import { useDirection } from '@mybridge/ui/custom-hooks/useDirection';

export const TeamDiskAcceptChangeDiskSubscriberModal = ({ onClose, title }) => {
  const {
    changeDiskSubscriberDisc,
    diskSubscriptionChangeRequests,
    cancelDiskSubscriptionChangeRequest,
    cancelDiskSubscriptionChangeRequestLoading,
    acceptDiskSubscriptionChangeRequest,
    acceptDiskSubscriptionChangeRequestLoading,
    teamDetails,
    diskSubscriptionChangeRequestDisc,
  } = useContext(TeamsContext);
  const { t } = useTranslator();
  
 const direction = useDirection();
  

  const [response, setResponse] = useState();
  const [savedChangeRequest, setSavedChangeRequest] = useState(null);

  // const handleSubmit = async () => {
  //   setResponse(resp);
  // };

  // Save the first valid change request to prevent flickering
  useEffect(() => {
    const currentRequest = diskSubscriptionChangeRequests?.[0];
    if (currentRequest && !savedChangeRequest) {
      setSavedChangeRequest(currentRequest);
    }
  }, [diskSubscriptionChangeRequests, savedChangeRequest]);

  const changeRequest = savedChangeRequest || diskSubscriptionChangeRequests?.[0];
  
  if(!changeRequest) return;
  return (
    <Modal {...diskSubscriptionChangeRequestDisc}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>
          <Text>{teamDetails?.name}{" "}
             {/* Disk Subscriber */}
             {t('myDisk.DiskSubscriber')||"Disk Subscriber"}
             </Text>
          <ModalCloseButton  {...(direction === 'rtl') ? {left: '0.75rem', right: 'auto'} : {left: 'auto', right: '0.75rem'}}/>
        </ModalHeader>

        {response === 'ALREADY_SENT' ? (
          <>
            <ModalBody>
              <Text>
                {t('myDisk.RequestAlreadySentToGet')||"Request already sent to get"}.
                {/* Request already sent to get. */}
                </Text>
            </ModalBody>
            <ModalFooter>
              <HStack justifyContent="flex-end">
                <Button
                  variant="secondary"
                  onClick={(e) => changeDiskSubscriberDisc?.onClose()}
                >
                  {/* Cancel Request */}
                  {t('myDisk.CancelRequest')||"Cancel Request"}
                </Button>
              </HStack>
            </ModalFooter>
          </>
        ) : (
          ''
        )}

        {!response ? (
          <>
            <ModalBody>
              {getUserFullName(changeRequest?.requested_by)}{" "}
               {/* is requesting you become the Subscriber for  */}
               {t("myDisk.isRequestingYouBecomeTheSubscriberFor")||"is requesting you become the Subscriber for"}
               {" "}
               {changeRequest?.team?.name}{" "} 
               {/* Disk */}
               {t("myDisk.Disk")||"Disk"}
               .
            </ModalBody>
            <ModalFooter>
              <HStack justifyContent="flex-end">
                <Button
                borderRadius="20px"

                  isLoading={cancelDiskSubscriptionChangeRequestLoading}
                  variant="secondary"
                  onClick={async (e) =>
                    await cancelDiskSubscriptionChangeRequest?.(changeRequest)
                  }
                >
                  {/* Reject */}
                  {t("myDisk.Reject")||"Reject"}
                </Button>

                <Button
                borderRadius="20px"
                  isLoading={acceptDiskSubscriptionChangeRequestLoading}
                  variant="primary"
                  onClick={async (e) =>
                    await acceptDiskSubscriptionChangeRequest?.(changeRequest)
                  }
                >
                  {/* Accept */}
                  {t("myDisk.Accept")||"Accept"}
                </Button>
              </HStack>
            </ModalFooter>
          </>
        ) : (
          ''
        )}
      </ModalContent>
    </Modal>
  );
};
